<template>
  <div>
    <v-card>
      <v-card-title class="primary--text"
        ><v-btn @click="back" class="ml-n7 primary--text" text>
          <v-icon>mdi-reply</v-icon></v-btn
        >Expense Masters</v-card-title
      >
      <v-tabs v-model="tab" background-color="transparent" color="primary" grow>
        <v-tab
          active-class="tab1"
          v-for="item in tabItems"
          :key="item"
          name="item"
          >{{ item }}</v-tab
        >
      </v-tabs>
    </v-card>

    <Roles v-if="tab == 0" />
    <Grade v-if="tab == 1" />
    <LoctionExpense v-if="tab == 2" />
  </div>
</template>
<script>
import Roles from "@/components/MasterSubFolder/Roles.vue";
import LoctionExpense from "@/components/MasterSubFolder/LoctionExpense.vue";
// import { apiCall } from "@/Views/APICALL/APIcall.js";
import Grade from "@/components/MasterSubFolder/Grade.vue";
export default {
  components: {
    Roles,
    LoctionExpense,
    Grade,
  },
  data: () => ({
    tab: 0,
    tabItems: ["Role", "Grade", "Location "],
  }),
  mounted() {},
  methods: {
    back() {
      this.$router.push("/Dashboard");
    },
  },
};
</script>
<style scoped>
.tab1 {
  background: linear-gradient(to bottom, #bdbdbd 0%, #bdbdbd 50%, #9e9e9e 100%);
  -webkit-text-fill-color: #2e4152;
  /* box-shadow: 0 0px 5px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23); */
}
</style>
